import { useLayoutEffect, useState } from 'react';
import { headerCallCount } from './headerActions';

export function useHeaderActions() {
  const [header, setHeader] = useState<HTMLDivElement | null>(null);
  const [callCount, setCallCount] = useState(0);
  useLayoutEffect(() => {
    if (!header) return;
    const measure = () => {
      const style = getComputedStyle(header);
      const gap = parseFloat(style.columnGap) || 0;
      const title = header.querySelector<HTMLElement>('.title');
      const fontSize = title ? parseFloat(getComputedStyle(title).fontSize) : 16;
      const scale = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--message-text-scale')) || 1;
      const buttons = Array.from(header.querySelectorAll<HTMLElement>(':scope > .back-btn, :scope > .header-select, :scope > .header-search, :scope > .header-more-btn'));
      const required = buttons.reduce((sum, button) => sum + button.getBoundingClientRect().width + gap, 0);
      const width = header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      // Аватар, промежуток и восемь символов имени; длинное имя сокращается многоточием.
      setCallCount(headerCallCount(width, required + 44 + 8 * fontSize * scale, 40 + gap));
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    const title = header.querySelector('.title');
    if (title) observer.observe(title);
    const settings = new MutationObserver(measure);
    settings.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
    return () => { observer.disconnect(); settings.disconnect(); };
  }, [header]);
  return { headerRef: setHeader, callCount };
}
